export default "__VITE_ASSET__0bf42fb7__"